import script from "./icon-two-tones-paypal.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-two-tones-paypal.vue?vue&type=script&lang=ts&setup=true"

import "./icon-two-tones-paypal.vue?vue&type=style&index=0&id=7bf94f9e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bf94f9e"]])

export default __exports__